<div class="chat-sidebar chat-list-container"
     [class.is-closed]="isSidebarClosed"
     #scrollContainer
     style="overflow-y: auto; height: 100%;">

  <div class="header-box" (click)="newChat()" [title]="__('newChatTooltip')">
    <div class="header-avatar">
      <img src="assets/icons/chatbot/JayIcon.svg" alt="Jay Avatar Icon">
      <span>{{__('new-chat-field')}}</span>
    </div>
    <button (click)="newChat()" class="id37-btn id37-btn-secondary id37-btn-transparent id37-btn-sm id37-btn-rounded-1 header-create-chat">
      <img alt="Create Chat Icon" src="assets/icons/ID37_Chatbot_Create_Chat.svg">
    </button>
  </div>

  <div class="chat-selections">

    <div *ngIf="chatbotChatService.isInitialLoading$ | async" class="loading-skeleton">
      <div class="chat-item-skeleton" *ngFor="let i of [1,2,3,4,5,6]">
        <div class="skeleton-avatar"></div>
        <div class="skeleton-content">
          <div class="skeleton-title"></div>
          <div class="skeleton-preview"></div>
        </div>
      </div>
    </div>

    <!-- Gruppierte Chat-Liste - Progressive Enhancement: Behalte existierende Chats während Refresh sichtbar -->
    <div *ngIf="groupedChats as groups; else loadingState" class="grouped-chat-list">
      <ng-container *ngFor="let group of groups | keyvalue: keepOrder">
        <div *ngIf="isGroupNotEmpty(group)" class="chat-group">
          <div class="chat-group-name">
            {{ __(group.key) }}
          </div>
          <div class="chat-list">
            <ng-container *ngFor="let chat of group.value; trackBy: trackByChatId">
              <app-chatbot-chat-selection
                [chatbotChat]="chat"
                [selectedChat]="selectedChat"
                (chatSelected)="selectChat($event)"
                (chatDeleted)="deleteChatFromChatList($event)">
              </app-chatbot-chat-selection>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- Infinite Scroll Loading -->
      <div *ngIf="pagination$ | async as pagination" class="pagination-footer">

        <div *ngIf="!pagination.hasMore && currentChatList.length > 0" class="all-loaded">
          <span>Alle Chats geladen</span>
        </div>

        <div *ngIf="pagination.error" class="error-state">
          <span>{{pagination.error}}</span>
          <button (click)="loadMoreChats()" class="retry-button">
            Erneut versuchen
          </button>
        </div>
      </div>
    </div>

    <!-- Loading State Template -->
    <ng-template #loadingState>
      <!-- Komplett leer für clean UI -->
    </ng-template>

    <!-- Empty State entfernt für clean UI -->

  </div>

  <!-- Footer with Buttons -->
  <div class="footer-layout">
    <div class="footer-row">
      <button class="id37-btn id37-btn-secondary id37-btn-transparent id37-btn-sm id37-btn-rounded-1 clear-all-button" (click)="openDeleteForm()">
        <img src="assets/icons/chatbot/TrashCanIcon.svg" alt="Clear conversations button"/>
        <span>{{__('delete-all-btn')}}</span>
      </button>

      <button class="id37-btn id37-btn-secondary id37-btn-transparent id37-btn-sm id37-btn-rounded-1 toggle-sidebar-button" (click)="toggleSidebar()">
        <img src="assets/icons/chatbot/SidebarButton.svg" alt="Toggle sidebar button"/>
      </button>
    </div>
  </div>
</div>


<id37-modal [(modalOpen)]="deleteFormOpen" [modalSize]="'small'">
  <id37-modal-title [align]="'left'" [showX]="false">{{__('deleteTitle')}}</id37-modal-title>
  <id37-modal-body>
      <span>
        {{__('deleteAllChats')}}
      </span>
  </id37-modal-body>
  <id37-modal-footer [align]="'right'">
    <div class="id37-btn-row button-row">
      <button class="id37-btn id37-btn-secondary id37-btn-rounded-1" (click)="closeDeleteForm()">
        <span>{{__('cancel')}}</span>
      </button>
      <button class="id37-btn id37-btn-primary id37-btn-rounded-1" (click)="deleteAllChats()">
        <img class="fit-parent" src="assets/icons/chatbot/TrashCanIconWhite.svg" alt="Trashcan Icon"/>
        <span>{{__('delete')}}</span>
      </button>
    </div>
  </id37-modal-footer>
</id37-modal>
